import { ApiClient } from "../../lib/ApiClient";
import { useGenericSWR } from "../../lib/useGenericSWR";

const apiClient = new ApiClient();
const apiEndpointBase = '/identity/2fa';
const pathLogin = apiEndpointBase + '/login';
const pathResendVerificationCode = apiEndpointBase + '/resend';
const pathLoginWithRecoveryCode = apiEndpointBase + '/loginWithRecoveryCode';

const useLogin = (swrOptions = {}) => {
    return useGenericSWR(pathLogin, apiClient, { ...swrOptions });
};

const login = (values) => {
    return apiClient.poster(pathLogin, values);
};

const resendVerificationCode = (twoFactorProvider) => {
    return apiClient.poster(pathResendVerificationCode + "?twoFactorProvider=" + twoFactorProvider);
};

const loginWithRecoveryCode = (code) => {
    return apiClient.poster(pathLoginWithRecoveryCode + "?code=" + code);
};

export {
    useLogin,
    login,
    resendVerificationCode,
    loginWithRecoveryCode
};